export const MODULE = 'BPLS_REPORTS';

export const UPLOAD = `${MODULE}/upload`;
export const LIST = `${MODULE}/list`;
export const FIRE_LIST = `${MODULE}/fire_list`;
export const AMNESTY_LIST = `${MODULE}/amnesty_list`;

export const KIND_OF_OWNERSHIP = [
  { label: 'ALL', value: '' },
  { label: 'SOLE PROPRIETORSHIP', value: 'SOLE PROPRIETORSHIP' },
  { label: 'ONE PERSON CORPORATION', value: 'ONE PERSON CORPORATION' },
  { label: 'PARTNERSHIP', value: 'PARTNERSHIP' },
  { label: 'CORPORATION', value: 'CORPORATION' },
  { label: 'COOPERATIVE', value: 'COOPERATIVE' },
];

export const REGISTRATION_STATUS = [
  { label: 'ALL', value: '' },
  { label: 'SUCCESSFUL', value: 'SUCCESSFUL' },
  { label: 'PENDING', value: 'PENDING' },
];
